import { Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";

@Injectable({providedIn:'root'})
export class IdleService{
    private timeout: any
    private readonly limit = 30 * 60 * 1000 // 30 secs for test

    constructor(private authService : MsalService){
        this.startWatching();
    }

    private startWatching(){
        ['click', 'mousemove', 'keydown', 'scroll'].forEach(event => window.addEventListener(event, ()=>this.resetTimer()))
    }

    public resetTimer(){
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.logout()
        }, this.limit);
    }

    public logout(){
        this.authService.logout()
    }
    
}